import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Typography } from 'antd';
import { FormInputArea } from '../form-helpers/FormField';

const { Title } = Typography;

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  }
}

const styles = {
  question: {
    fontWeight: "300",
    fontSize: "12px",
    lineHeight: "20px",
    textAlign: "center",
    letterSpacing: "0.02em",
    color: "#8C8C8C",
    marginBottom: 25,
    marginTop: 50
  }
}

const MobileTextAreaQuestion = ({fieldName, question}) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext();

  return (
    <>
      {
        question && (
          <Title level={4} style={styles.question}>
            {t(`${question}`)}
          </Title>
        )
      }
      <FormInputArea
        name={fieldName}
        style={{ width: '100%', padding: '3%' }}
        formItemLayout={formItemLayout}
        onChange={(e) => setFieldValue(fieldName, e.target.value)}
        value={values[fieldName]}
        rows={6}
      />
    </>
  );
}

export default MobileTextAreaQuestion;
